var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenwu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78046 13.144H1.5789C1.37314 13.144 1.17925 13.0491 1.06054 12.8868C0.945792 12.7325 0.91018 12.5386 0.965576 12.3526L2.86885 6.02161H15.25L14.3834 8.90619C14.3516 9.00525 14.2821 9.08785 14.19 9.13621C14.0979 9.18456 13.9904 9.19479 13.8908 9.1647C13.7912 9.13461 13.7074 9.0666 13.6574 8.97533C13.6075 8.88405 13.5954 8.77681 13.6237 8.67669L14.1856 6.81299H3.45842L1.79653 12.3526H8.78046C8.99809 12.3526 9.17615 12.5307 9.17615 12.7483C9.17615 12.966 8.99809 13.144 8.78046 13.144Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57316 13.144H0.866638V2.85608H6.90091L7.67251 4.43884H13.2122V6.41729H12.4208V5.23022H7.1779L6.4063 3.64746H1.65802V12.3526H3.57316V13.144Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7848 13.144H9.80921L8.32141 10.5681L9.80921 7.99213H12.7848L14.2726 10.5681L12.7848 13.144ZM10.2682 12.3526H12.3298L13.3585 10.5681L12.3298 8.78351H10.2682L9.23941 10.5681L10.2682 12.3526Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7193 10.5681C10.7193 10.6439 10.7342 10.7191 10.7632 10.7892C10.7923 10.8593 10.8348 10.923 10.8885 10.9766C10.9421 11.0303 11.0058 11.0729 11.0759 11.1019C11.146 11.1309 11.2211 11.1459 11.297 11.1459C11.3729 11.1459 11.448 11.1309 11.5181 11.1019C11.5882 11.0729 11.6519 11.0303 11.7055 10.9766C11.7592 10.923 11.8017 10.8593 11.8308 10.7892C11.8598 10.7191 11.8747 10.6439 11.8747 10.5681C11.8747 10.4922 11.8598 10.4171 11.8308 10.347C11.8017 10.2769 11.7592 10.2132 11.7055 10.1595C11.6519 10.1059 11.5882 10.0633 11.5181 10.0343C11.448 10.0052 11.3729 9.99026 11.297 9.99026C11.2211 9.99026 11.146 10.0052 11.0759 10.0343C11.0058 10.0633 10.9421 10.1059 10.8885 10.1595C10.8348 10.2132 10.7923 10.2769 10.7632 10.347C10.7342 10.4171 10.7193 10.4922 10.7193 10.5681Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenwu);
export default __webpack_public_path__ + "static/media/renwu.f8bae561439d9a71ad135af7d185aae5.svg";
export { ForwardRef as ReactComponent };